module.exports = __webpack_public_path__ + "static/media/logodashboard.16383020.png";